

import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Select, MenuItem, FormHelperText, TextField, InputAdornment, Grid, RadioGroup, FormControlLabel, Radio, Checkbox } from '@material-ui/core'
import { ReactComponent as EquipmentSvg } from '../../assets/equipment-type.svg';
import { InsurancePurchaseContextStore, INSURANCE_CONTEXT_ACTIONS } from '../../context/InsuracePurchaseContext';
import { HullItemSelectView } from './HullItemSelectView';
import './HullAddForm.css'
import { EquipmentType } from '../../models/hull-models/EuipmentTypes';
import FlexView from 'react-flexview/lib';
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService';
import { ImageDropzone } from '../Core/Dropzone/ImageDropzone';
import NewFillButton from '../Core/NewFillButton';
import { HullApi } from '../../api/hull.api';
import { awaitWithLoading, billingPeriodPretty } from '../../services/utils';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { Action } from '../../models/Action';
import { useLocation, useParams } from 'react-router-dom';
import { PolicyHullExtensionContextStore, ACTIONS } from '../../context/PolicyHullExtensionContext';
import { COUNTRIES, HULL_MAX_LENGTH_SERIAL_NUMBER, HULL_MIN_LENGTH_SERIAL_NUMBER, UK_HULL_MIN_LENGTH_SERIAL_NUMBER } from '../../Constants';
import { COVERAGE_TYPES } from '../../models/insurance-models/CoverageType';
import { SessionService } from '../../services/SessionService';
import { OptionalTag } from '../Core/OptionalTag';
import HelpIcon from '@material-ui/icons/Help';
import LightTooltip from "../Core/LightTooltip";
import { HomeBuiltPopover } from '../Core/Popover/HomeBuiltPopover';
import { InsuranceBillingPeriod } from '../../models/insurance-models/InsuranceBillingPeriodModel';
import { RequesetSupportTag } from '../Core/RequestSupportTag';
import DataLayerService from '../../services/DataLayerService';
import { ModificationContextStore } from '../../context/ModificationContext';
import EditIcon from '@material-ui/icons/Edit';
import { is } from 'date-fns/locale';
import { SessionContextStore } from '../../context/SessionContext';
const EQUIPMENT_TYPE_DEFAULT = 'equipment'
const DRONE_WEIGHT_TYPE_DEFAULT = 'noweight'


export const HullAddForm = (props) => {
    const { register, watch,  triggerValidation, setValue, errors, control, getValues} = useForm(props.editMode ? { defaultValues: props.defaultValues, mode: 'onChange' } : { mode: 'onChange', defaultValues: { type: props.openEquipmentFirst ? EQUIPMENT_TYPE_DEFAULT : 'drone', "is_home_built" : false, 'is_rented': false} })
    const { register: registerEquipment, triggerValidation: triggerValidationEquipment, control: equipmentControl,
         errors: errorsEquipment, getValues: getValuesEquipment, watch: watchEquipment, setValue: setValueEquipment } = useForm({defaultValues: props.editMode ? {...props.defaultValues} : { quantity: 1, 'is_rented': false } , mode: 'onChange'})
    const location = useLocation()
    const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)
    const policyExtensionContext = useContext(PolicyHullExtensionContextStore)
    const modificationContext = React.useContext(ModificationContextStore) 
    const sessionContext = React.useContext(SessionContextStore)

    const isPolicyManagementMode = () => location.pathname.includes('policy-management')
    const context = isPolicyManagementMode() ? policyExtensionContext : insurancePurchaseContext
    const [hasImage, setHasImage] = useState(props.defaultValues && !!props.defaultValues.drone_image_id)
    const watchType = watch('type', props.editMode ? props.defaultValues.type : props.openEquipmentFirst ? EQUIPMENT_TYPE_DEFAULT : 'drone')
    const watchIsRented = watch('is_rented')
    const watchEquipmentIsRented = watchEquipment('is_rented')
    let insuranceType = isPolicyManagementMode()?
    props.carrier === 'Global' ?  modificationContext.billingPeriod : props.insuranceType
    : insurancePurchaseContext.selectedOption.billingPeriod;
    const [showImageRequired, setShowImageRequired] = useState(false);
    const [spearPartSelected, setSpearPartSelected ] = useState(false);
    const [spearPartDisabled, setSpearPartDisabled] = useState(false);
    const [isEditDeductibleMode, setIsEditDeductibleMode] = useState(false);
    const [serialNumberRequired,setSerialNumberRequired] = useState(false);
    const carrier = props.carrier !== undefined ? props.carrier : "Global"
    const maximumDroneValue = SessionService.isAdmin() ? FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_DRONE_VALUE_FOR_ADMIN) : (SessionService.isBroker()? FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_DRONE_VALUE_FOR_BROKER) : FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_DRONE_VALUE))
    const maximumEquipmentValue = SessionService.isAdmin() ? Number.MAX_SAFE_INTEGER : (SessionService.isBroker()? FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_EQUIPMENT_VALUE_FOR_BROKER) : FirebaseService.getNumber(FirebaseConfigKey.MAXIMUM_EQUIPMENT_VALUE))
    const isDroneForm = () => watchType == 'drone'
    const changeDroneImage = () => setHasImage(false)
    const initialDeductibleRate = ((context.isGlobalRatings ? 
    FirebaseService.getValue(insuranceType.startsWith(InsuranceBillingPeriod.MONTH)? FirebaseConfigKey.HULL_ESTIMATED_DEDUCTIBLE_FACTOR : FirebaseConfigKey.HULL_ESTIMATED_DEDUCTIBLE_FACTOR_ANNUAL) 
    :FirebaseService.getValue(insuranceType.startsWith(InsuranceBillingPeriod.MONTH)? FirebaseConfigKey.HULL_ESTIMATED_DEDUCTIBLE_FACTOR_STARR : FirebaseConfigKey.HULL_ESTIMATED_DEDUCTIBLE_FACTOR_ANNUAL_STARR))*100).toFixed(0)
    const EQUIPMENT_CHECKBOX_TYPES = ["Camera","Lens","Gimbal"]

    const validateDeductible = (deductibleStr) => {
        const regex = /^[0-9]+$/
        var isInt = regex.test(deductibleStr)
        if(!isInt) return false

        const deductible = parseInt(deductibleStr)
        return!!deductible && deductible <= 100 && deductible >=1
    }

    const onDroneImageDrop = async (files) => {
        let res = await awaitWithLoading(HullApi.uploadDroneImage(files[0]))
        if(!res.ok && res.status === 415) {
            EventEmitterService.dispatch(EventKey.ShowMessageBox, {title: "Unsupported file type!", body: "Please choose a different file"})
            return;
        }
        const {drone_image_id} = res.data;
        if(drone_image_id) {
            setValue('drone_image_id', drone_image_id)
            setHasImage(true)
            setShowImageRequired(false);
        }
        else {
          EventEmitterService.dispatch(EventKey.ShowError, res)
        }
    }

    const onChangeEquipmentType = (type) =>{
        setSpearPartSelected(type === 'Spare part')
        setSerialNumberRequired(type === 'Camera' || type === 'Sensor' ||type === 'Lens' ||type === 'Gimbal' || type === 'Controller')

    }

    const isBrokerWithNonMandatoryImageUpload = () => {
        return SessionService.isBroker() && !FirebaseService.getBoolean(FirebaseConfigKey.DRONE_IMAGE_REQUIRED_FOR_BROKER);
    }

    const isImageRequired = (drone) => {
        if(carrier === "Global")
            return false
        // If the drone already has an image 
        if(hasImage) 
            return false
        if (insuranceType == InsuranceBillingPeriod.YEAR){
            return false;
        }
        // If the drone value is greater than minimum and the broker have to upload drone pictures
        else if(drone && drone.value > FirebaseService.getNumber(FirebaseConfigKey.MINIMUM_HULL_VALUE_FOR_IMAGE_MANDATORY) && !isBrokerWithNonMandatoryImageUpload())
            return true
        // If editing a drone in PolicyManagement then image is required
        else if(isPolicyManagementMode() && !props.editMode && !isBrokerWithNonMandatoryImageUpload())
            return true;
        else 
            return false
    }

    const onSubmit = async () => {
        if(isDroneForm()) {
            let valid = await triggerValidation()
            if(valid) {
                const form = getValues();
                sessionContext.setUserCommercial() 
                if(!form?.deductible_rate || form.deductible_rate === 0){
                    form.deductible_rate = initialDeductibleRate
                }
                if (form?.rent_company_address === ""){
                    delete form.rent_company_address;
                }
                if (isImageRequired(form)) {
                    setShowImageRequired(true);
                    return;
                }
                else{
                    setShowImageRequired(false);
                }

                if(props.editMode) {
                    if(props.editingInsuredHull) 
                        context.editInsuredDrone(form, props.editIndex)
                    else 
                        context.editDrone(form, props.editIndex)
                }
                else {
                    context.addDrone(form)
                    DataLayerService.pushToDataLayer({'event': 'drone-pop-up-saved'})
                }
            }
        }
        else {
            let validEquipmentDetails = await triggerValidationEquipment()
            let validType = await triggerValidation('type')
            if(validType && validEquipmentDetails) {
                let eq = getValuesEquipment()
                if(!eq?.deductible_rate || eq.deductible_rate === 0){
                    eq.deductible_rate = initialDeductibleRate
                }
                eq.type = getValues().type
                eq.equipment_sub_type =context.equipmentTypes.find(x=>x.name === eq.type).subType
                if (eq?.rent_company_address === ""){
                    delete eq.rental_company_address;
                }
                if(props.editMode) {
                    if(props.editingInsuredHull) 
                        context.editInsuredEquipment(eq, props.editIndex)
                    else 
                        context.editEquipment(eq, props.editIndex)
                }
                else {
                    context.addEquipment(eq)
                    DataLayerService.pushToDataLayer({'event': 'equipment-pop-up-saved'})
                }
            }
        }
    }

    const isRentedChange = (event) => {
        setValue("is_rented", event.target.value == 'true' ? true : false);
    };
    const equipmentIsRentedChange = (event) => {
        setValueEquipment("is_rented", event.target.value == 'true' ? true : false);
    };

    useEffect(() => {
        register({ name: "drone_image_id" }); 
        register({ name: "is_home_built" }); 
        register({ name: "is_rented" });
        registerEquipment({ name: "is_rented" });
    }, [register])

    useEffect(() => {
        if(carrier === "Global")
        {
            const equipmentsType = props.equipment.map(equ => equ.type)
            const isSparePartInTheList = equipmentsType.includes('Spare part')
            setSpearPartDisabled(isSparePartInTheList)
        }
    },[insurancePurchaseContext.equipment])

    const saveDeductibleRate = (isValid) => {
        if(isValid){
            setIsEditDeductibleMode(!isEditDeductibleMode)
        }
    }

    const showDroneEquipmentCheckbox = () => {
        return EQUIPMENT_CHECKBOX_TYPES.includes(watch("type"))
    }
    
    return (
        <React.Fragment>
            {!isPolicyManagementMode() && <div className="text-title blue bold textcenter title-hull-popup">Add the {isDroneForm() ? 'drone' : 'equipment'} you would like to insure</div>}
            <RequesetSupportTag tag={'hull_drones_value'} text={'For Hull values above $20K and drone weight above 35lbs,'} />
            <Controller control={control} 
                rules={{validate: x => x && x != 'type' && x != EQUIPMENT_TYPE_DEFAULT}} 
                name="type" 
                as={
                <Select style={{display: isDroneForm() ? 'none' : undefined}} fullWidth>
                    {isDroneForm() && <MenuItem value={"drone"}><HullItemSelectView type={new EquipmentType('Drone')} /></MenuItem>}
                    <MenuItem value={EQUIPMENT_TYPE_DEFAULT} disabled> <FlexView vAlignContent={'bottom'}><EquipmentSvg className="medium-icon" /><div className="text-body lightgrayblue margin-left-6">Select equipment</div></FlexView>
                    </MenuItem>
                    {context.equipmentTypes.map(
                        (type, index) => {
                    return (<MenuItem disabled={type.name === 'Spare part' && spearPartDisabled} 
                    onClick = {(x)=>{onChangeEquipmentType(type.name)}}key={index} value={type.name}> <HullItemSelectView type={type} /> </MenuItem>)})}
                </Select>} />
                {!!errors.type && <FormHelperText error={!!errors.type}>Must Select Item Type</FormHelperText>}
                
                
                <FlexView column className="margin-top-medium">
                    {isDroneForm() && 
                        <React.Fragment>
                            <TextField variant="outlined" label="Make" name="make" inputRef={register({required: true})} helperText={errors.make ? 'Make is required' : 'e.g: DJI'} error={!!errors.make} />
                            <TextField variant="outlined" className="margin-top-small" label="Model" name="model" inputRef={register({required: true})} helperText={errors.model ? 'Model is required' : 'e.g: Phantom 4 pro'} error={!!errors.model} />
                            <Grid className="margin-top-small" container spacing={2}>
                                <Grid item xs>
                                    <TextField fullWidth variant="outlined" label="Serial Number" name="serial" 
                                        inputRef={register({required: true, minLength: HULL_MIN_LENGTH_SERIAL_NUMBER,
                                                                             maxLength: HULL_MAX_LENGTH_SERIAL_NUMBER})} 
                                        helperText={errors.serial && `Serial must be between ${HULL_MIN_LENGTH_SERIAL_NUMBER} - ${HULL_MAX_LENGTH_SERIAL_NUMBER} characters`} error={!!errors.serial} />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField 
                                            disabled={(isPolicyManagementMode() && props.editMode && props.editingInsuredHull )}
                                            variant="outlined" label="Value" type="number" name="value" 
                                            InputProps={{startAdornment: <InputAdornment position="start">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}</InputAdornment>}} 
                                            inputRef={register({required: true, min: FirebaseService.getNumber(FirebaseConfigKey.MINIMUN_DRONE_VALUE), max: maximumDroneValue})} 
                                            helperText={errors.value && `Value must be between ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${FirebaseService.getNumber(FirebaseConfigKey.MINIMUN_DRONE_VALUE)} - ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${maximumDroneValue.toLocaleString()}`} 
                                            error={!!errors.value} />
                                </Grid>
                            </Grid>
                            {!!errors.value && <RequesetSupportTag tag={'hull_drones_value'} text={'For higher drone value'} />}

                            {FirebaseService.getValue(FirebaseConfigKey.COUNTRY) == COUNTRIES.UK && <>
                                <Controller control={control} 
                                    rules={{validate: x => x && x != DRONE_WEIGHT_TYPE_DEFAULT, required: true}} 
                                    name="weight" 
                                    defaultValue={getValues()["weight"] || DRONE_WEIGHT_TYPE_DEFAULT}
                                    
                                    as={<Select error={!!errors.weight} variant="outlined" className="margin-top-small">
                                            <MenuItem disabled value={DRONE_WEIGHT_TYPE_DEFAULT}><div className="placeholder-text">Weight (KG)</div></MenuItem>
                                            {FirebaseService.getArray(FirebaseConfigKey.DRONE_TAKEOFF_WEIGHTS).map(w => <MenuItem key={w} value={w}>{w}</MenuItem>)}
                                    </Select>} 
                                />
                                <FormHelperText error={!!errors.weight}>Select Weight (KG)</FormHelperText>
                            </>}
                            
                            
                            <ImageDropzone changeImage={changeDroneImage} hasImage={hasImage} onDrop={onDroneImageDrop} isImageMandatory={isImageRequired(getValues())} showImageRequired={carrier === "Global" ? false : showImageRequired}/>
                            <Grid container alignItems='center' justifyContent='space-between'>
                                <Grid item>
                                    <div className="">Is this drone rented?</div>
                                </Grid>
                                <Grid item>
                                    <RadioGroup onChange={isRentedChange} value={watchIsRented ? 'true' : 'false'}>
                                        <div>
                                            <FormControlLabel label="No" value={"false"} control={<Radio color="primary" />} />
                                            <FormControlLabel label="Yes" value={"true"} control={<Radio color="primary" />} />
                                        </div>
                                    </RadioGroup>
                                </Grid>
                            </Grid>
                            { watchIsRented && 
                            <Grid container spacing={2}> 
                                <Grid item xs={12}>
                                    <TextField variant="outlined" label="Rental company name" name="rent_company_name" 
                                        fullWidth
                                        inputRef={register({required: watchIsRented})} 
                                        helperText={errors.rent_company_name && `You must specify rental company name`} 
                                        error={!!errors.rent_company_name} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField variant="outlined" label="Rental company address" name="rent_company_address"
                                        fullWidth
                                        inputRef={register({required: false})} 
                                        InputProps={{endAdornment: <InputAdornment position="end"><OptionalTag /> </InputAdornment>}}
                                        helperText={errors.rent_company_address && `You must specify rental company address`} 
                                        error={!!errors.rent_company_address} />
                                </Grid>
                            </Grid> }
                            { !sessionContext.user.commercial && <Grid container direction='row' wrap='nowrap' spacing={1}>
                                <Grid item>
                                    <input type='checkbox' id="rpac" name="rpac" ref={register({required: true})}/>
                                </Grid>
                                <Grid item>
                                    <label htmlFor="rpac">I confirm that all operators hold a valid Remote Pilot Airman Certificate (RPAC) or Under a Certificate of Authorization or Waiver (public entities only)</label>
                                    {errors.rpac && <div style={{color: 'red'}}>Required</div>}
                                </Grid>
                            </Grid>}
                        </React.Fragment>
                    }

                    {!isDroneForm() && 
                        <React.Fragment>
                            <TextField variant="outlined" label="Item description" name="description" inputRef={registerEquipment({required: true})} helperText={errorsEquipment.description ? 'Item description is required' : 'Describe your item, for example, Zenmuse X5S Camera'} error={!!errorsEquipment.description} />
                            {!(spearPartSelected && carrier === "Global") &&
                            <TextField className="margin-top-basic" variant="outlined" 
                            label="Serial" name="serial" inputRef={registerEquipment}  inputRef={registerEquipment({required: serialNumberRequired})}
                            helperText={errorsEquipment.serial && 'Serial is required'} 
                            error={!!errorsEquipment.serial} 
                            InputProps={{endAdornment: <InputAdornment> {serialNumberRequired ? <div></div> : <OptionalTag />} </InputAdornment>}} />}
                            <Grid className="margin-top-basic" container spacing={2}>
                                <Grid item xs={6}>
                                    <TextField variant="outlined" label="Value" type="number" name="value" 
                                                disabled={isPolicyManagementMode() && props.editMode && props.editingInsuredHull}
                                                InputProps={{startAdornment: <InputAdornment position="start">{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}</InputAdornment>}} 
                                                inputRef={registerEquipment({required: true, min: FirebaseService.getNumber(FirebaseConfigKey.MINIMUN_EQUIPMENT_VALUE), max: maximumEquipmentValue})} 
                                                helperText={errorsEquipment.value && `Value must be between ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${FirebaseService.getNumber(FirebaseConfigKey.MINIMUN_EQUIPMENT_VALUE)} - ${FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}${maximumEquipmentValue.toLocaleString()}`} 
                                                error={!!errorsEquipment.value} />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        disabled={isPolicyManagementMode() && props.editMode}
                                        variant="outlined" label="Quantity" type="number" name="quantity" inputRef={registerEquipment({required: true, validate: x => x > 0})} helperText={errorsEquipment.quantity && 'Quantity is required'} error={!!errorsEquipment.quantity} />
                                </Grid>
                            </Grid>
                            {!!errorsEquipment.value && <RequesetSupportTag tag={'hull_equipment_value'} text={'For higher equipment value'} />}
                            <Grid container alignItems='center' justifyContent='space-between'>
                                <Grid item>
                                    <div className="">Is this equipment rented?</div>
                                </Grid>
                                <Grid item>
                                    <RadioGroup onChange={equipmentIsRentedChange} value={watchEquipmentIsRented ? 'true' : 'false'}>
                                        <div>
                                            <FormControlLabel label="No" value={"false"} control={<Radio color="primary" />} />
                                            <FormControlLabel label="Yes" value={"true"} control={<Radio color="primary" />} />
                                        </div>
                                    </RadioGroup>
                                </Grid>
                            </Grid>
                            { watchEquipmentIsRented && 
                            <Grid container spacing={2}> 
                                <Grid item xs={12}>
                                    <TextField variant="outlined" label="Rental company name" name="rental_company_name" 
                                        fullWidth
                                        inputRef={registerEquipment({required: watchEquipmentIsRented})} 
                                        helperText={errorsEquipment.rental_company_name && `You must specify rental company name`} 
                                        error={!!errorsEquipment.rental_company_name} />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField variant="outlined" label="Rental company address" name="rental_company_address"
                                        fullWidth
                                        inputRef={registerEquipment({required: false})} 
                                        InputProps={{endAdornment: <InputAdornment position="end"><OptionalTag /> </InputAdornment>}}
                                        helperText={errorsEquipment.rental_company_address && `You must specify rental company address`} 
                                        error={!!errorsEquipment.rental_company_address} />
                                </Grid>
                            </Grid> }

                            {showDroneEquipmentCheckbox() && 
                            <Grid className="margin-top-basic" container direction='row' wrap='nowrap' spacing={1}>
                                <Grid item>
                                    <input type='checkbox' id="drone_equipment" name="drone_equipment" ref={registerEquipment({required: true})}/>
                                </Grid>
                                <Grid item>
                                    <label htmlFor="drone_equipment">
                                        I am aware that only drone-related equipment is eligible for coverage.
                                        For example, attachable cameras or a ground control station are eligible, but standalone cameras or lenses are not.
                                    </label>
                                    {errorsEquipment.drone_equipment && <div style={{color: 'red'}}>Required</div>}
                                </Grid>
                            </Grid>}
                        </React.Fragment>}
                          

                    { carrier === "Global"? 
                        <>
                            <NewFillButton onClick={onSubmit}>{props.editMode ? "Save" : `Add this to the insurance plan`}</NewFillButton>
                                {FirebaseService.getValue(FirebaseConfigKey.SHOULD_DISPLAY_HULL_ESTIMATIONS) && 
                                    <div className="text-small textcenter margin-bottom-basic ">
                                    <span className="margin-left-6">
                                         {!SessionService.isAdmin() ?
                                            
                                            <span style={{fontSize: '1rem'}}><span className='bold'>Deductible </span> -{isDroneForm() ? 
                                                (getValues()["deductible_rate"]) == undefined ? initialDeductibleRate : 
                                                (getValues()["deductible_rate"]):(getValuesEquipment()["deductible_rate"]) == undefined ? initialDeductibleRate : (getValuesEquipment()["deductible_rate"])}%
                                            </span>
                                            :
                                            isDroneForm() ? <>
                                            <FlexView vAlignContent='center' hAlignContent='left'>
                                            <span className='bold'>Deductible </span>  -
                                                <span style={{display: !isEditDeductibleMode ? "inherit" : "none"}}>
                                                    <span style={{margin: 'auto', fontSize: '1rem'}}>{(getValues()["deductible_rate"]) == undefined ? initialDeductibleRate : (getValues()["deductible_rate"])}%</span>
                                                    <span className="margin-left-basic blue" onClick={() => setIsEditDeductibleMode(!isEditDeductibleMode)}><EditIcon/><span className='underline'>Edit</span></span>
                                                </span>
                                                <span className='textcenter' style={{display: isEditDeductibleMode ? "inherit" : "none"}}>
                                                <Controller
                                                    control={control}
                                                    name= "deductible_rate"
                                                    style= {{width: '30px'}}
                                                    rules={{validate: validateDeductible}}
                                                    defaultValue={initialDeductibleRate}
                                                    as={
                                                        <TextField
                                                        className="margin-left-6, textcenter"
                                                        
                                                        defaultValue={initialDeductibleRate}
                                                        name= "deductible_rate"
                                                        error={!!errors.deductible_rate} 
                                                        />
                                                    }
                                                />
                                                <FlexView vAlignContent='center'>
                                                <span  className="margin-left-basic green underline" onClick={() => saveDeductibleRate(!errors.deductible_rate)}>Save</span>
                                                 </FlexView>
                                                 
                                                 </span>
                                            </FlexView>
                                            {!!errors.deductible_rate &&<FlexView vAlignContent='center' hAlignContent='left' className='text-small red margin-top-6'>Value must be 1-100</FlexView>}
                                            </>
                                            :
                                            <>
                                            <FlexView vAlignContent='center' hAlignContent='left'>
                                            <span className='bold'>Deductible </span>  -
                                                <span style={{display: !isEditDeductibleMode ? "inherit" : "none"}}>
                                                    <span style={{margin: 'auto', fontSize: '1rem'}}>{(getValuesEquipment()["deductible_rate"]) == undefined ? initialDeductibleRate : (getValuesEquipment()["deductible_rate"])}%</span>
                                                    <span className="margin-left-6 blue" onClick={() => setIsEditDeductibleMode(!isEditDeductibleMode)}><EditIcon/><span className='underline'>Edit</span></span>
                                                </span>
                                                <span className='textcenter' style={{display: isEditDeductibleMode ? "inherit" : "none"}}>
                                                <Controller
                                                    control={equipmentControl}
                                                    name= "deductible_rate"
                                                    style= {{width: '30px'}}
                                                    rules={{validate: validateDeductible}}
                                                    defaultValue={initialDeductibleRate}
                                                    as={
                                                        <TextField
                                                        className="margin-left-6, textcenter"
                                                        defaultValue={initialDeductibleRate}
                                                        name= "deductible_rate"
                                                        error = {!!errorsEquipment.deductible_rate}
                                                        />
                                                    }
                                                />
                                                <FlexView vAlignContent='center'>
                                                    <span className="margin-left-basic green underline" onClick={() =>  saveDeductibleRate(!errorsEquipment.deductible_rate)}>Save</span>
                                                </FlexView>
                                                 </span>
                                            </FlexView>
                                            {!!errorsEquipment.deductible_rate &&<FlexView vAlignContent='center' hAlignContent='left' className='text-small red margin-top-6'>Value must be 1-100</FlexView>}
                                            </>
                                        }
                                    </span>
                                    </div>
                                }
                        </>
                        :
                        <>
                            <NewFillButton onClick={onSubmit}>{props.editMode ? "Save" : `Add this to the insurance plan`}</NewFillButton>
                                {FirebaseService.getValue(FirebaseConfigKey.SHOULD_DISPLAY_HULL_ESTIMATIONS) && 
                                <div className="text-small blue bold textcenter margin-bottom-basic margin-top-small">
                                {billingPeriodPretty(insuranceType)} Premium - {(FirebaseService.getValue(insuranceType.startsWith(InsuranceBillingPeriod.MONTH)? FirebaseConfigKey.HULL_ESTIMATED_PREMIUM_FACTOR_STARR : FirebaseConfigKey.HULL_ESTIMATED_PREMIUM_FACTOR_ANNUAL_STARR) * 100).toFixed(2)}% 
                                <span className="margin-left-6">Deductible - {(initialDeductibleRate * 100).toFixed(0)}%</span></div>}
                        </>}
                </FlexView> 
        </React.Fragment>
    )
}